import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLTestClient, NotificationStyles, NotificationTypes } from "./api/cplapi/CPLAPI";

export interface ITestService {
  createCompletedBackgroundProcess(): Promise<void>;
  createFailedBackgroundProcess(): Promise<void>;
  testSignalRNotification(
    userID: string,
    notificationType: NotificationTypes,
    notificationStyle: NotificationStyles
  ): Promise<void>;
  sendDocumentToPrint(): Promise<void>;
  generateServiceChargeInvoice(): Promise<File>;
  generateAnticipatedExpenditureReport(): Promise<File>;
}

@injectable()
export class TestService implements ITestService {
  @inject(SERVICE_TYPES.CPLTestClient) cplTestClient!: ICPLTestClient;

  createCompletedBackgroundProcess(): Promise<void> {
    return this.cplTestClient.createCompletedBackgroundProcess();
  }

  createFailedBackgroundProcess(): Promise<void> {
    return this.cplTestClient.createFailedBackgroundProcess();
  }

  testSignalRNotification(
    userID: string,
    notificationType: NotificationTypes,
    notificationStyle: NotificationStyles
  ): Promise<void> {
    return this.cplTestClient.testSignalRNotification(userID, notificationType, notificationStyle);
  }

  sendDocumentToPrint(): Promise<void> {
    return this.cplTestClient.sendDocumentToPrint();
  }

  async generateServiceChargeInvoice(): Promise<File> {
    const fileResponse = await this.cplTestClient.generateServiceChargeInvoice();
    return new File([fileResponse.data], fileResponse.fileName!);
  }
  async generateAnticipatedExpenditureReport(): Promise<File> {
    const fileResponse = await this.cplTestClient.generateAnticipatedExpenditureReport();
    return new File([fileResponse.data], fileResponse.fileName!);
  }
}
